import { type ReactNode } from 'react';
import { createRoute, Link } from '@tanstack/react-router';
import { Route as rootRoute } from './__root.js';
import { Button } from '../components/ui/Button.js';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/terms',
  component: TermsPage,
});

/** Brand chrome shared with the auth pages. */
function Shell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream p-6">
      <div className="w-full max-w-md">
        <div className="mb-8 flex items-center gap-3 justify-center">
          <div className="h-9 w-9 rounded-lg bg-navy flex items-center justify-center">
            <span className="font-serif text-cream text-lg leading-none">A</span>
          </div>
          <div className="font-serif text-2xl tracking-tighter2 text-ink">Admitly</div>
        </div>
        <div className="bg-white border border-line rounded-2xl shadow-card p-8">{children}</div>
      </div>
    </div>
  );
}

// NOTE: Placeholder page. The real Terms of Service content is a separate
// pre-launch task and must be published before public launch.
function TermsPage() {
  return (
    <Shell>
      <div className="text-center">
        <h1 className="font-serif text-2xl text-ink tracking-tight mb-2">Terms of Service</h1>
        <p className="text-sm text-muted mb-6">
          Our full Terms of Service will be published here before launch.
        </p>
        <Link to="/get-started">
          <Button variant="secondary" className="w-full">
            Back to sign-up
          </Button>
        </Link>
      </div>
    </Shell>
  );
}
